export enum LicenseStatus {
	ACTIVE = 'Active',
	PENDING = 'Pending',
	EXPIRED = 'Expired',
	SUSPENDED = 'Suspended',
	REVOKED = 'Revoked',
}
